import { View } from "react-native";
import { useTailwind } from "tailwind-rn";

import { Recurrence } from "../../../types";
import CardText from "../../CardText";
import StatusLabel from "../../StatusLabel";

type Props = {
  payments: Recurrence["payments"];
};

export default function RecurrencePayments({ payments }: Props) {
  const tailwind = useTailwind();

  if (!payments.length) {
    return null;
  }

  return (
    <View style={tailwind("mt-1")}>
      {payments.map(({ timestamp, status }, index) => (
        <View style={tailwind("flex-row justify-between mt-2")} key={index}>
          <CardText.Body text={timestamp} />
          <StatusLabel {...status} />
        </View>
      ))}
    </View>
  );
}
